import type { RouteObject } from 'react-router-dom'

import { Component } from '@/modules/onboarding/pages/Onboarding'
import { EditComponent } from '@/modules/onboarding/pages/OnboardingEdit'
import { OnboardingRoutePathsEnum } from '@/modules/onboarding/routes/onboardingRouteConfig.types'

export const ONBOARDING_ROUTES: RouteObject[] = [
  {
    element: <Component />,
    path: OnboardingRoutePathsEnum.ONBOARDING,
  },
]

export const ONBOARDING_EDIT_ROUTES: RouteObject[] = [
  {
    element: <EditComponent />,
    path: OnboardingRoutePathsEnum.ONBOARDING_EDIT,
  },
]
